import React from "react";
import { Header } from "./Header";
import { Hero } from "./Hero";
import { Marquee } from "./Marquee";
import { About } from "./About";
import { Services } from "./Services";
import { Portfolio } from "./Portfolio";
import { Audit } from "./Audit";
import { WhyUs } from "./WhyUs";
import { Reviews } from "./Reviews";
import { FinalCTA } from "./FinalCTA";
import { Footer } from "./Footer";

export default function HomePage() {
  return (
    <div className="grain min-h-screen overflow-x-hidden bg-white font-sans text-ink">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Portfolio />
        <Audit />
        <WhyUs />
        <Reviews />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
